import React from "react";

import { useLingui } from "@lingui/react";
import TranslateIcon from "@uui/Translate01";

import { Button, ButtonProps, Typography } from "@mui/material";
import styled from "@mui/material/styles/styled";

import useAnchorElement from "@app/utils/hooks/useAnchorElement";

import { Row } from "@rui/Stack";

import LocaleMenu from "./LocaleMenu";

export const LocaleSwitcherButton = styled<React.FC<ButtonProps>>((props) => (
  <Button disableRipple {...props} />
))(({ theme }) => ({
  minWidth: "45px",
  borderRadius: theme.corners.base,
  padding: theme.spacing(0.5),
  backgroundColor: theme.palette.transparent.white[4],
  "&:hover": {
    backgroundColor: theme.palette.overlay.primary[28],
  },
}));

interface LocaleSwitcherProps {
  onClose?: () => void;
}

/** Locale Switcher used on Desktop site */
const LocaleSwitcher = ({ onClose }: LocaleSwitcherProps) => {
  const { i18n } = useLingui();

  const {
    anchorElement,
    open,
    onClick,
    onClose: onCloseMenu,
  } = useAnchorElement();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (!open) {
      onClick(event);
    }
  };

  const handleClose = () => {
    onCloseMenu();
    onClose?.();
  };

  return (
    <>
      <LocaleSwitcherButton
        data-test-id="side-nav-locale-menu"
        onClick={handleClick}
      >
        <Row alignItems="center" gap="4px">
          <TranslateIcon
            sx={{
              width: "16px",
              height: "16px",
              color: "transparent.white.40",
            }}
          />
          <Typography variant="labelMed" color="#FFF">
            {i18n.locale.toUpperCase()}
          </Typography>
        </Row>
      </LocaleSwitcherButton>
      <LocaleMenu
        open={open}
        anchorEl={anchorElement}
        anchorPosition={{ top: 100, left: 249 }}
        anchorReference="anchorPosition"
        marginThreshold={0}
        onClose={handleClose}
      />
    </>
  );
};

export default LocaleSwitcher;
